import React,{ createContext, useState , useEffect, useMemo } from "react";
import PropTypes from 'prop-types';
import AuthService from "../service/auth.service";
import axios from "axios";

export const UserContext = createContext(null);

export const UserContextProvider = ({children}) => {
    const [userprofile, setUserprofile] = useState({});
    useEffect(() => {
        const user = AuthService.getCurrentUser();
        if(user){
            const token = localStorage.getItem("token").replace(/['"]+/g, '');
            // GET USER PROFILE DATA
            axios.get(`https://internal.orevan-prox.com/orevan_requests/get_current_user/`, { headers: {"Authorization" : `Token ${token}`} })  
                .then((res) => {
                    setUserprofile(res.data);
                })
                .catch((err) => {
                console.log(err);
                });

        }else{
            setUserprofile('');
        }
    },[]);

    const values = useMemo(
		() => ({
			userprofile,
            setUserprofile,
			
		}),
		[
			userprofile,
            setUserprofile,
		],
	);

    return (
        <UserContext.Provider value={values}>
            {children}
        </UserContext.Provider>
    );
};

UserContextProvider.propTypes = {
	children: PropTypes.node.isRequired,
};

export default UserContext;